import pulse from '@finn-no/pulse-sdk';
import { Action } from '../common.js';

export type EventData = {
    eventName: string;
    purposeName: string;
    dataCategory: string;
    accept: 'Subscribe' | 'Accept';
    reject: 'Unsubscribe' | 'Reject';
};

const trackedSchibstedEvents: Array<EventData> = [
    {
        eventName: 'Analyse and product development',
        dataCategory: 'sdrn:schibsted:datacategory:general',
        purposeName:
            'sdrn:spid.no:processingpurpose:analytics_and_product_development',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
    {
        eventName: 'See relevant content',
        dataCategory: 'sdrn:schibsted:datacategory:general',
        purposeName: 'sdrn:spid.no:processingpurpose:personalised_news',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
    {
        eventName: 'Content based on age',
        dataCategory: 'sdrn:schibsted:datacategory:age',
        purposeName: 'sdrn:spid.no:processingpurpose:targeted_advertising',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
    {
        eventName: 'Content based on interest',
        dataCategory: 'sdrn:schibsted:datacategory:interests',
        purposeName: 'sdrn:spid.no:processingpurpose:targeted_advertising',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
    {
        eventName: 'Content based on gender',
        dataCategory: 'sdrn:schibsted:datacategory:gender',
        purposeName: 'sdrn:spid.no:processingpurpose:targeted_advertising',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
    {
        eventName: 'Content based on area',
        dataCategory: 'sdrn:schibsted:datacategory:geolocation',
        purposeName: 'sdrn:spid.no:processingpurpose:targeted_advertising',
        accept: 'Subscribe',
        reject: 'Unsubscribe',
    },
];

export function onGDPRInfoSchibsted() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'GDPR info on Schibsted',
        target: {
            id: 'gdpr-info-schibsted',
            referralCommission: false,
            provider: 'Schibsted',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'common_pages',
            subVertical: 'profile',
        },
    });
}

function trackUpdate(eventData: EventData, action: Action) {
    if (eventData) {
        const eventAction = (() => {
            switch (action) {
                case Action.ACCEPTED:
                    return eventData.accept;
                case Action.WITHDRAWN:
                    return eventData.reject;
            }
        })();

        pulse.trackEvent({
            type: 'Click',
            intent: eventAction,
            name: eventData.eventName,
            object: {
                id: 'userprofilepage:privacy:ua_pv02',
                type: 'UIElement',
                elementType: 'Checkbox',
            },
            vertical: {
                name: 'common_pages',
                subVertical: 'profile',
            },
        });
    }
}

export function trackUpdateSchibstedConsent(
    activity: Activity,
    action: Action,
) {
    let eventData = trackedSchibstedEvents.find((event) => {
        return (
            event.purposeName === activity.purpose &&
            event.dataCategory === activity.dataCategory
        );
    });

    if (eventData === undefined) {
        eventData = {
            eventName: activity.dataCategory + ' ' + activity.purpose,
            dataCategory: activity.dataCategory,
            purposeName: activity.purpose,
            accept: 'Subscribe',
            reject: 'Unsubscribe',
        };
    }

    trackUpdate(eventData, action);
}

export function onSmartAdvertising() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Smart advertising',
        target: {
            id: 'smart-advertising',
            referralCommission: false,
            provider: 'Schibsted',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UIElement',
            elementType: 'Link',
        },
        vertical: {
            name: 'common_pages',
            subVertical: 'profile',
        },
    });
}
